import { render } from "./ThreeDObjectEditorCmp.vue?vue&type=template&id=39e6bcce&scoped=true"
import script from "./ThreeDObjectEditorCmp.vue?vue&type=script&lang=js"
export * from "./ThreeDObjectEditorCmp.vue?vue&type=script&lang=js"

import "./ThreeDObjectEditorCmp.vue?vue&type=style&index=0&id=39e6bcce&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e6bcce"]])

export default __exports__